var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"left-menu-block-wrapper"},[_c('div',{staticClass:"left-menu-block-inner"},[_c('ul',{staticClass:"left-menu user-menu"},[_c('AdminNavigationItems')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }